"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledFontAwesomeIcon = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _omit = _interopRequireDefault(require("lodash/omit"));

var _text = require("../../../styles/2_commonComponentStyles/text");

var iconSizes = _interopRequireWildcard(require("../../../styles/2_commonComponentStyles/icon"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StyledFontAwesomeIcon = (0, _styledComponents.default)(function (props) {
  return /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, (0, _omit.default)(props, ['inheritColor', 'colorTheme', 'size']));
}).withConfig({
  displayName: "iconstyles__StyledFontAwesomeIcon",
  componentId: "sc-1tw25us-0"
})(["vertical-align:middle;&,& *{color:", ";", "}&&&&&.override,&&&&&.override *{background-color:", ";color:", ";", "}"], function (props) {
  return !props.inheritColor && (0, _text.getForegroundColor)(props);
}, function (props) {
  return iconSizes["icon".concat(props.size.charAt(0).toUpperCase() + props.size.slice(1))];
}, function (props) {
  return props.theme.c_background_default;
}, function (props) {
  return !props.inheritColor && (0, _text.getForegroundColor)(props);
}, function (props) {
  return iconSizes["icon".concat(props.size.charAt(0).toUpperCase() + props.size.slice(1))];
});
exports.StyledFontAwesomeIcon = StyledFontAwesomeIcon;